/*
 * Copyright (C) Fraunhofer IESE 2021-2024 - Pedram (Majid) Jokar, Mher Ter-Tovmasyan,
 * Bestin John, Steffen Hupp, Anna Kleiner, Rafael Aranda Lopez King, Emily Calvet, Philipp Ewen,
 * Matthias Gerbershagen, Milad Chatrangoon, Stefan Schweitzer
 *
 * SPDX-License-Identifier: AGPL-3.0-or-later
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <https://www.gnu.org/licenses/>.
 */

import { chooseOrganizationPage } from './chooseOrganizationPage';
import { invitationsPage } from './invitationsPage';
import { draftPage } from './onboarding/draftPage';
import { requestsPage } from './onboarding/requestsPage';
import { organizationsPage } from './organizationsPage';
import { profilePage } from './profilePage';
import { solutionsPage } from './solutionsPage';
import { toasts } from './toasts';

export const de = {
  appName: 'DEUTSCHLAND.DIGITAL-Konto',
  profile: 'Profil',
  organizations: 'Organisationen',
  requests: 'Anfragen',
  solutions: 'Lösungen',
  invitations: 'Einladungen',
  legal: 'Rechtliches',
  email: 'E-Mail',
  solutionBar: {
    backToSolutionWithName: 'Zurück zu "{{solutionName}}"',
    backToSolutionWithoutName: 'Zurück zur Lösung'
  },
  navBar: {
    appName: 'DEUTSCHLAND.\nDIGITAL',
    account: 'KONTO',
    logout: 'Abmelden'
  },
  error: {
    title: 'Hoppla, etwas lief schief!',
    noResponse: 'Der Server reagiert nicht.\nBitte versuch es später erneut.',
    options:
      'Wir schauen uns das Problem umgehend an. Falls du Hilfe benötigst oder Fragen hast, wende dich gerne ans <0>DEUTSCHLAND.DIGITAL Support Team</0>!',
    toHome: 'Zur Startseite',
    toLandingPage: 'Zu DEUTSCHLAND.DIGITAL',
    toOrganizations: 'Zur Organisationen'
  },
  form: {
    apply: 'Übernehmen',
    mandatoryField: '*Pflichtfeld',
    counter: '{{count}} / {{maxCount}} Zeichen',
    maxCharLengthError:
      'Maximale Zeichenlänge überschritten. Bitte kürze den Text.'
  },
  accessibility: {
    appURLLabel: 'Zurück zur Profilseite',
    navigateToLabel: 'Navigiere zur URL:',
    navigateBackLabel: 'Zurück zur vorherigen Seite',
    fallbackImageAlt: 'Platzhalter Bild (Original konnte nicht geladen werden)',
    profilePictureAlt: 'Profilbild',
    accordion: {
      deleteButtonLabel: 'Lösch-Taste',
      dragButtonLabel: 'Ziehen-Taste'
    },
    menuToggleLabel: 'Optionen'
  },
  footer: {
    links: {
      title: 'Nützliche Links',
      privacyPolicy: 'Datenschutzhinweise',
      termsOfUse: 'Allgemeine Geschäftsbedingungen',
      imprint: 'Impressum'
    },
    help: {
      title: 'Fragen & Hilfe',
      contactUs: 'Einfach das Kontaktformular verwenden.',
      lookingForward: 'Wir freuen uns schon!',
      contact: 'Kontakt',
      help: 'Hilfe'
    },
    project: {
      title: 'Das Projekt',
      description:
        'DEUTSCHLAND.DIGITAL-Konto wird vom BMLEH als Fördermittelgeber und des KomLE der BLE als Geschäftsstelle gefördert.<br></br><br></br>Verantwortlich für die Umsetzung des Forschungsprojekts ist das Fraunhofer IESE, eines der weltweit führenden Forschungseinrichtungen auf dem Gebiet der Software- und Systementwicklungsmethoden.'
    },
    bmleh: 'Förderhinweis Logo'
  },
  toasts,
  profilePage,
  organizationsPage,
  solutionsPage,
  chooseOrganizationPage,
  invitationsPage,
  draftPage,
  requestsPage
};
